import styles from "./HowThisWorks.module.scss";
import { CloudinaryImage } from "../../../../Atoms/Cloudinary";
export default function HowThisWorks() {
  return (
    <div className={styles.HowDisWorks}>
      <p
        style={{
          fontSize: 26,
          fontWeight: "bold",
          paddingBottom: 10,
          borderBottom: "1px solid",
          marginBottom: 20,
        }}
      >
        How MagicalTrip works
      </p>
      <div className={styles.DisBlock}>
        <div>
          <b>1. Book your tour</b>
          <p>
            Select an available time slot you wish to join a tour and proceed to
            payment. You can make payments using credit cards or PayPal.
            <br />
            Your booking is confirmed instantly.
          </p>
        </div>
        <div className={styles.DisImageContainer}>
          <CloudinaryImage
            src={
              "https://res.cloudinary.com/dbm1qiew0/image/upload/v1703050312/recruit/Mask_group.jpg"
            }
            transformations={["w_320", "h_240", "c_fill"]}
          />
        </div>
      </div>

      <div className={styles.DisBlock}>
        <div>
          <b>2. Receive a confirmation email</b>
          <p>
            Right after booking, we&apos;ll send you a confirmation email. This
            email includes your reservation date and time, a Google Maps link to
            the meeting point, and other booking details. If you don&apos;t
            receive your confirmation email within one hour, please reach out to
            us at{" "}
            <a
              href="https://www.magical-trip.com/contact-us"
              target="_blank"
              style={{ color: "blue", textDecoration: "underline" }}
            >
              https://www.magical-trip.com/contact-us
            </a>
            .
          </p>
        </div>
        <div className={styles.DisImageContainer}>
          <CloudinaryImage
            src={
              "https://res.cloudinary.com/dbm1qiew0/image/upload/v1703050312/recruit/Mask_group-1.jpg"
            }
            transformations={["w_320", "h_240", "c_fill"]}
          />
        </div>
      </div>

      <div className={styles.DisBlock}>
        <div>
          <b>3. Meet your guide and the tour starts!</b>
          <p>
            Our tours are operated in English! Please arrive at the meeting
            point 10 minutes before your reserved time. Look for a guide holding
            an orange board with &quot;MagicalTrip&quot; written on it. When you
            meet your guide, just let the guide know your reservation name. If
            you have trouble finding the meeting point, please contact us
            through{" "}
            <a
              href="https://www.magical-trip.com/contact-us"
              target="_blank"
              style={{ color: "blue", textDecoration: "underline" }}
            >
              https://www.magical-trip.com/contact-us
            </a>
            . Our customer support team will assist you promptly.
          </p>
        </div>
        <div className={styles.DisImageContainer}>
          <CloudinaryImage
            src={
              "https://res.cloudinary.com/dbm1qiew0/image/upload/v1703050312/recruit/Mask_group-2.jpg"
            }
            transformations={["w_320", "h_240", "c_fill"]}
          />
        </div>
      </div>

      <div className={styles.DisBlock}>
        <div>
          <b>4. Receive your tour photos</b>
          <p>
            During the tour, your guide will take some beautiful scenery and
            group photos in the tour. After the tour, we will send you a URL via
            email where you can view your memorable experiences in photos.
            Preserve your unforgettable moments through these pictures!
          </p>
        </div>
        <div className={styles.DisImageContainer}>
          <CloudinaryImage
            src={
              "https://res.cloudinary.com/dbm1qiew0/image/upload/v1703050312/recruit/Mask_group-3.jpg"
            }
            transformations={["w_320", "h_240", "c_fill"]}
          />
        </div>
      </div>
    </div>
  );
}
